import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui-kit/card';
import { Skeleton } from '@/components/ui-kit/skeleton';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  Clock01Icon,
  ShieldUserIcon,
  UserGroupIcon,
  UserMultiple02Icon,
} from '@hugeicons/core-free-icons';
import type { TeamStats } from '../types/org-users.types';

interface StatsCardsProps {
  stats: TeamStats;
  isLoading?: boolean;
}

export const StatsCards = ({ stats, isLoading }: StatsCardsProps) => {
  const { t } = useTranslation();

  const cards = [
    {
      id: 'admins',
      label: t('ORGTEAM_STATS_ADMINS'),
      count: stats.admins,
      icon: ShieldUserIcon,
      color: '#6DAEFF',
    },
    {
      id: 'editors',
      label: t('ORGTEAM_STATS_EDITORS'),
      count: stats.editors,
      icon: UserMultiple02Icon,
      color: '#9A7CEF',
    },
    {
      id: 'members',
      label: t('ORGTEAM_STATS_MEMBERS'),
      count: stats.members,
      icon: UserGroupIcon,
      color: '#00A671',
    },
    {
      id: 'pending',
      label: t('ORGTEAM_STATS_PENDING'),
      count: stats.pending,
      icon: Clock01Icon,
      color: '#FF7803',
    },
  ];

  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => (
          <Card key={i}>
            <CardContent className="pt-6">
              <div className="flex items-center gap-4">
                <Skeleton className="size-12 rounded-lg" />
                <div className="space-y-2">
                  <Skeleton className="h-7 w-12" />
                  <Skeleton className="h-4 w-16" />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <Card
          key={card.id}
          className="border-y-0 border-r-0 border-l-4 py-4 gap-4 shadow-sm"
          style={{ borderColor: card.color }}
        >
          <CardHeader className="flex flex-row items-center gap-2 space-y-0 pb-2 md:py-3! py-0! ">
            <HugeiconsIcon icon={card.icon} size={20} className="size-6 text-globe-grey" />
            <CardTitle className="text-sm font-semibold font-nunito text-secondary-400!">
              {card.label}
            </CardTitle>
          </CardHeader>
          <CardContent className="flex flex-row items-center justify-center p-3! pb-0!">
            <p className="text-xl md:text-3xl font-semibold">{card.count}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
